import React from 'react';
import './styles/global.css';
import './styles/animations.css';
import './styles/responsive.css';

import useScrollReveal from './hooks/useScrollReveal';
import useNavScroll    from './hooks/useNavScroll';

import Cursor     from './components/ui/Cursor';
import Navbar     from './components/layout/Navbar';
import Footer     from './components/layout/Footer';
import BackToTop  from './components/ui/BackToTop';   // ← NEW
import Hero       from './components/sections/Hero';
import Services   from './components/sections/Services';
import About      from './components/sections/About';
import Projects   from './components/sections/Projects';
import Process    from './components/sections/Process';
import Team       from './components/sections/Team';
import Contact    from './components/sections/Contact';
import TechMarquee from './components/ui/TechMarquee';

const App: React.FC = () => {
  useScrollReveal();
  useNavScroll();

  return (
    <>
      <Cursor />
      <Navbar />
      <main>
        <Hero />
        <TechMarquee />
        <Services />
        <About />
        <Projects />
        <Process />
        <Team />
        <Contact />
      </main>
      <Footer />
      <BackToTop />   {/* ← renders fixed bottom-right */}
    </>
  );
};

export default App;